export default "skymp5-front/b1a05148aa1a4f5377d70b18ef598e83.png";